<one-card [notPadding]="true">

  <div class="fh-table-header">
    <span class="fh-table-title">Purchase orders</span>
    <one-input
      #searchInput
      class="fh-search"
      label="Search"
      type="search"
      autocomplete="off"
      (input)="onSearch($event)"
    ></one-input>
  </div>

  <div class="fh-divider"></div>

  <div class="fh-filters">
    <div class="fh-filters-left">
      <div class="fh-filter-item" *ngIf="isBusinessUnitFilterVisible">
        <one-select
          #businessUnitSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [dataSource]="businessUnitDataSource"
          [label]="FILTER_LABEL.BUSINESS_UNIT"
          size="small"
          (selectionChanged)="onBusinessUnitChange(businessUnitSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item" *ngIf="isMakerFilterVisible">
        <one-select
          #makerSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="makerDataSource"
          [label]="FILTER_LABEL.MAKER"
          size="small"
          (selectionChanged)="onMakerChange(makerSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item" *ngIf="isBrandGroupFilterVisible">
        <one-select
          #brandGroupSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="brandGroupDataSource"
          [label]="FILTER_LABEL.BRAND_GROUP_TO_EXECUTE"
          size="small"
          (selectionChanged)="onBrandGroupChange(brandGroupSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #companySelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="companyDataSource"
          label="Company to bill"
          size="small"
          (selectionChanged)="onCompanyChange(companySelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #sourceTypeSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [multiple]="true"
          [dataSource]="sourceTypeDataSource"
          label="Source type"
          size="small"
          (selectionChanged)="onSourceTypeChange(sourceTypeSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #poTypeSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [multiple]="true"
          [dataSource]="poTypeDataSource"
          label="PO type"
          size="small"
          (selectionChanged)="onPoTypeChange(poTypeSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #statusSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="statusDataSource"
          label="Status"
          size="small"
          (selectionChanged)="onStatusChange(statusSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #ownerSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="ownerDataSource"
          label="Owner"
          size="small"
          (selectionChanged)="onOwnerChange(ownerSelect.control.value)"
        ></one-select>
      </div>
      <!-- Approved-at range — one compact box. mat-date-range-input drives both bounds
           through the same FormControls (matStartDate/matEndDate are CVAs), so the
           valueChanges → onApprovedAtChange → refetch wiring is unchanged. The shared
           range calendar makes an inverted range unpickable; the error span below stays
           as defense for programmatic writes (same reasoning as buildFilters' re-check). -->
      <div class="fh-filter-item fh-filter-item--date-range">
        <div class="fh-date-picker">
          <mat-form-field>
            <mat-label>Approved at</mat-label>
            <mat-date-range-input [rangePicker]="approvedRangePicker" [max]="todayDate">
              <input matStartDate readonly [formControl]="approvedActions.pendingStart">
              <input matEndDate readonly [formControl]="approvedActions.pendingEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="approvedRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #approvedRangePicker
              [panelClass]="POPUP_CLASS"
              appApprovedPickerActions
              #approvedActions="appApprovedPickerActions"
              [start]="filterApprovedFrom"
              [end]="filterApprovedTo"
            ></mat-date-range-picker>
          </mat-form-field>
        </div>
        <span class="fh-filter-error" aria-live="polite" *ngIf="approvedAtError">'To' date must be after 'from'</span>
      </div>
    </div>
    <div class="fh-filters-right" *ngIf="isAdmin">
      <label class="fh-po-test-checkbox">
        <input
          type="checkbox"
          class="rp-switch"
          [(ngModel)]="filterIsTest"
          (change)="onTestToggle()"
        >
        <span>POs test</span>
      </label>
    </div>
  </div>

  <one-dynamic-table *ngIf="tableData" [tableData]="tableData"></one-dynamic-table>

</one-card>

<ng-template #truncatedTextTemplate let-value="value" let-maxLength="maxLength">
  <span
    class="fh-truncated-text"
    [appCustomTooltip]="value"
    tooltipPosition="top"
    [showToolTip]="value.length > maxLength"
  >{{ value.length > maxLength ? value.slice(0, maxLength) + '…' : value }}</span>
</ng-template>

<!-- PO name cell — truncated text plus the effective-test badge. isTest comes from
     records[].is_test (effective: column OR DEV / "Test PO" tag), which the backend does
     not send yet; the badge simply stays hidden until that deploy lands. -->
<ng-template #poNameTemplate let-value="value" let-maxLength="maxLength" let-isTest="isTest">
  <span class="fh-po-name-cell">
    <span
      class="fh-truncated-text"
      [appCustomTooltip]="value"
      tooltipPosition="top"
      [showToolTip]="value.length > maxLength"
    >{{ value.length > maxLength ? value.slice(0, maxLength) + '…' : value }}</span>
    <span class="fh-test-badge" *ngIf="isTest">Test</span>
  </span>
</ng-template>

<ng-template #sourceTypeTemplate let-sourceType="sourceType" let-colorClass="colorClass">
  <span class="fh-source-badge" [ngClass]="colorClass">
    <span class="fh-source-dot"></span>{{ sourceType }}
  </span>
</ng-template>

<ng-template #statusTemplate let-label="label" let-code="code">
  <span class="fh-status-badge" [ngClass]="'fh-status--' + code">{{ label }}</span>
</ng-template>

<ng-template #actionsTemplate let-po="po" let-statusCode="statusCode">
  <div class="fh-row-actions">
    <button *ngIf="canViewDetail(po)" class="fh-row-actions__btn"
            (click)="viewOrder(po, statusCode)"
            [title]="statusCode === 'draft' ? 'Edit purchase order' : 'View purchase order'">
      <span class="one-icon-open-eyes"></span>
    </button>
  </div>
</ng-template>
